import {
  pageViewStatistics,
} from '@/utils/const'

let index: any = null

export const stayTime = (to: any) => {
  if (index) {
    pageViewStatistics({
      pageId: index,
      start: 0
    })
  }
  if (to.meta && to.meta.pageKey) {
    index = to.meta.pageKey
    pageViewStatistics({
      pageId: index,
      start: 1
    })
  } else {
    index = null
  }
}
